<template>
  <div class="hp-feature-stores-container d-flex">
    <div :class="{ row: isDesktop }">
      <section
        class="feature-store primary col-12 col-xl-8"
        :class="{ container: !isDesktop }"
        v-if="featureOne"
      >
        <div class="feature-image">
          <NuxtImg
            :src="featureOne[0].image_url + '?auto=format,compress&fm=webp'"
            :alt="
              featureOne[0].image_url_alt_text ||
              featureOne[0].name ||
              'Store image'
            "
            :modifiers="{ format: 'webp' }" 
          />
        </div>

        <div class="caption" v-if="featureOne[0].callout">
          {{ featureOne[0].callout }}
        </div>
        <h2 class="title" v-if="featureOne[0].name">
          {{ featureOne[0].name }}
        </h2>
        <div
          class="description"
          v-if="featureOne[0].description"
          v-html="featureOne[0].description"
        ></div>
        <nuxt-link
          v-if="featureOne[0].url"
          class="feature-link"
          :to="featureOne[0].url"
          :aria-label="`Read more about ${featureOne[0].name}`"
        >
          {{ featureOne[0].link_text ? featureOne[0].link_text : "Read More" }}
        </nuxt-link>
      </section>

      <section
        class="feature-store secondary col-12 col-xl-4"
        :class="{ container: !isDesktop }"
        v-if="featureTwo"
      >
        <div class="feature-image">
          <NuxtImg
            :src="featureTwo[0].image_url + '?auto=format,compress&fm=webp'"
            :alt="
              featureTwo[0].image_url_alt_text ||
              featureTwo[0].name ||
              'Store image'
            "
            :modifiers="{ format: 'webp' }" 
          />
        </div>
        <div class="caption" v-if="featureTwo[0].callout">
          {{ featureTwo[0].callout }}
        </div>
        <h2 class="title" v-if="featureTwo[0].name">
          {{ featureTwo[0].name }}
        </h2>
        <div
          class="description"
          v-if="featureTwo[0].description"
          v-html="featureTwo[0].description"
        ></div>
        <nuxt-link
          v-if="featureTwo[0].url"
          class="feature-link"
          :to="featureTwo[0].url"
          :aria-label="`Read more about ${featureTwo[0].name}`"
        >
          {{ featureTwo[0].link_text ? featureTwo[0].link_text : "Read More" }}
        </nuxt-link>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useMainStore } from "~/store/index";

const store = useMainStore();
const { isMobile, isDesktop } = useMobileChecker();

// PROPS
const props = defineProps(["featuredStores"]);

const featureOne = _filter(props.featuredStores, (el) => {
  return el.is_featured_on_home_page && el.position_featured_on_home_page === 1;
});

const featureTwo = _filter(props.featuredStores, (el) => {
  return el.is_featured_on_home_page && el.position_featured_on_home_page === 2;
});
</script>

<style lang="scss" scoped>
.hp-feature-stores-container {
  margin: 20px 0 50px;
  .feature-store {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      border-bottom: 8px solid $black;
    }

    &.primary {
      padding-right: 25px;
      padding-left: 0;

      &::after {
        left: 0;
        right: 25px;
      }
    }

    &.secondary {
      padding-left: 25px;
      padding-right: 0;

      &::after {
        left: 25px;
        right: 0;
      }
    }

    .feature-image {
      width: 100%;
      height: 390px;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .caption {
      font-family: $font_poppin_bold;
      font-size: 11px;
      text-transform: uppercase;
      color: $black;
      line-height: 10px;
      margin: 10px 0 20px 0;
      letter-spacing: 1.5px;
    }

    .title {
      font-family: $font_didot_italic;
      font-style: italic;
      text-transform: uppercase;
      letter-spacing: -1px;
      font-size: 30px;
      margin: 0 0 6px 0;
      color: $black;
    }

    .description {
      margin: 0 0 5px 0;
      font-family: $font_didot_regular;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: -0.5px;
      text-transform: normal;
      padding-right: 10px;
      color: $black;

      :deep(p) {
        margin-bottom: 0 !important;
      }
    }

    .feature-link {
      margin-top: auto;
      display: flex;
      justify-content: flex-end;
      text-align: right;
      text-decoration: underline;
      font-family: $font_poppin_bold;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      margin-bottom: 15px;
    }

    @media only screen and (max-width: 1024px) {
      height: auto;
      margin: 30px auto;

      &.primary,
      &.secondary {
        padding-right: 30px;
        padding-left: 30px;

        &::after {
          left: 30px;
          right: 30px;
        }
      }

      .description {
        padding-right: 1px;
      }

      .feature-link {
        margin-bottom: 20px;
      }
    }

    @media only screen and (max-width: 580px) {
      height: auto;
      margin: 20px auto;

      &.primary,
      &.secondary {
        padding-right: 0px;
        padding-left: 0px;

        &::after {
          left: 0px;
          right: 0px;
        }
      }
      .feature-image {
        width: 100%;
        height: 200px;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
      }
    }
  }
}
</style>